import React, { useState } from "react";
import { Button } from "react-bootstrap";
import FieldSelect from "../Fields/FieldSelect";
import AlertComponent from "../AlertComponent";

function AddExistingInputs(props) {
  const { handleAddNewElementsInput, existingInputsOptions } = props;
  const [selectedExistingInputs, setSelectedExistingInputs] = useState([]);

  const onSubmitHandler = () => {
    if (!selectedExistingInputs) {
      return AlertComponent("Error", "Select at least one input.", {
        icon: `error`,
      });
    }

    selectedExistingInputs?.map((x) => {
      handleAddNewElementsInput(x.value);
    });
  };

  return (
    <div className="choose-">
      <FieldSelect
        label={`Select the inputs`}
        options={existingInputsOptions}
        id={`selectedExistingInputs`}
        name={`selectedExistingInputs`}
        onChange={setSelectedExistingInputs}
        value={selectedExistingInputs}
        placeholder={`Choose the inputs`}
        multiple={true}
      />

      <Button
        className="dark-btn"
        onClick={onSubmitHandler}
        disabled={
          !selectedExistingInputs || selectedExistingInputs.length === 0
        }
      >
        Add
      </Button>
    </div>
  );
}

export default AddExistingInputs;
